import { parseWithValibot as conformParse } from "conform-to-valibot";
import {
  getFormProps,
  getInputProps,
  useForm,
} from "@conform-to/react";
import {
  type MetaFunction,
  type ActionFunctionArgs,
  json,
  redirect,
} from "@remix-run/cloudflare";
import { parse } from "valibot";
import {
  Form,
  useActionData,
  useNavigation,
} from "@remix-run/react";
import clsx from "clsx";
import ErrorDisplay from "~/components/Common/ErrorDisplay";
import {
  NOT_ALOOW_INPUT,
  signUp,
} from "~/utils/authUtils";
import { createSbClientSSR } from "~/utils/createSbClientSSR";

import { LoginSchema } from "~/types/schema";
import {
  buttonBase,
  inputBase,
} from "~/components/Common/FormStyle";
import { useEffect } from "react";

import {
  DEFAULT_DESCRIPTION,
  TITLE_SUFFIX,
} from "~/utils/const";
import { UserService2 } from "~/database/user2.service";

export const meta: MetaFunction = () => {
  return [
    { title: "会員登録" + TITLE_SUFFIX },
    {
      name: "description",
      content: DEFAULT_DESCRIPTION,
    },
  ];
};

// add the loader
export async function loader({
  request,
  context,
}: ActionFunctionArgs) {
  const headers = new Headers();
  const supabase = createSbClientSSR(
    headers,
    request,
    context,
  );
  const userResponse =
    await supabase.auth.getSession();
  if (!userResponse.data.session?.user.id) {
    return null;
  }
  const userData = await UserService2.getUser(
    supabase,
    userResponse.data.session?.user.id as string,
  );
  console.log("userData:", userData);
  if (
    !userData.data &&
    userResponse.data.session?.user.id
  ) {
    await supabase.auth.signOut();
    return null;
  }
  if (userResponse.data.session) {
    return redirect("/dashboard", {
      headers: headers,
    });
  }
  return null;
}

export async function action({
  request,
  context,
}: ActionFunctionArgs) {
  try {
    const url = new URL(request.url);
    const siteURLRoot = url.origin;
    console.log("siteURLRoot:", siteURLRoot);
    const headers = new Headers();
    const supabase = createSbClientSSR(
      headers,
      request,
      context,
    );
    const formData = await request.formData();
    const dataFields = Object.fromEntries(
      formData.entries(),
    );
    const submission = conformParse(formData, {
      schema: LoginSchema,
    });
    console.log("111:", 111);
    if (submission.status !== "success") {
      return json({
        ok: false,
        error: {
          auth: NOT_ALOOW_INPUT,
          ...submission.error,
        },

        submission,
      });
    }
    const { email, password } = parse(
      LoginSchema,
      dataFields,
    );

    const response = await signUp(
      supabase,
      {
        email: email as string,
        password: password as string,
      },
      siteURLRoot,
    );

    if (response.data && response.data.user) {
      if (
        response.data.user.identities &&
        response.data.user.identities.length > 0
      ) {
        return json(
          {
            ok: true,
            error: null,
            user: response.data.user,
          },
          {
            headers: headers,
          },
        );
      } else {
        console.log("4444:", 4444);
        const signInResponse =
          await supabase.auth.signInWithPassword({
            email: email as string,
            password: password as string,
          });
        if (signInResponse.error) {
          return json(
            {
              error: {
                auth: "exist user",
              },
              ok: false,
            },
            {
              headers: headers,
            },
          );
        } else {
          return redirect("/dashboard", {
            headers: headers,
          });
        }
      }
    } else {
      console.log(
        "response.error?.message:",
        response.error?.message,
      );
      if (
        response.error?.message ===
        "User already registered"
      ) {
        const signInResponse =
          await supabase.auth.signInWithPassword({
            email: email as string,
            password: password as string,
          });
        if (signInResponse.error) {
          return json(
            {
              error: {
                auth: "exist user",
              },
              ok: false,
            },
            {
              headers: headers,
            },
          );
        } else {
          return redirect("/dashboard", {
            headers: headers,
          });
        }
      }
      return json(
        {
          error: {
            auth: "unknown error",
          },
          ok: false,
        },
        {
          headers: headers,
        },
      );
    }
  } catch (e) {
    return json({
      error: {
        auth: "unknown error",
      },
      ok: false,
    });
  }
}

export default function Index() {
  const data = useActionData<typeof action>();
  useEffect(() => {
    if (data?.ok) {
      const isLocal =
        window.location.hostname === "localhost";
      if (isLocal) {
        window.open(
          "http://127.0.0.1:54324/monitor",
          "_self",
        );
      }
    }
  }, [data?.ok]);

  const [form, { email, password }] = useForm({
    onValidate({ formData }) {
      const check = conformParse(formData, {
        schema: LoginSchema,
      });
      return check;
    },
  });

  const { state } = useNavigation();
  return (
    <div className={clsx("pt-96")}>
      <h1
        className={clsx(
          "font-bold",
          "text-lg",
          "text-center",
        )}
      >
        REGISTER
      </h1>
      <div
        className={clsx(
          "mx-auto max-w-contentMd",
          "mt-48",
        )}
      >
        {data?.ok && (
          <div
            className={clsx(
              "text-center",
              "border",
              "border-gray-400",
              "rounded-md",
              "p-16",
              "mb-32",
              "bg-gray-100",
            )}
          >
            <h2
              className={clsx(
                "font-bold",
                "text-16",
                "mb-8",
                "text-center",
              )}
            >
              登録が完了しました
            </h2>
            <div className={clsx("text-14")}>
              メールアドレス確認用のメールを送信しました。
              <br />
              メールアドレスが確認されるとアカウント作成完了となります。
            </div>
          </div>
        )}
        {!data?.ok && (
          <Form
            method="post"
            {...getFormProps(form)}
          >
            <div
              className={clsx(
                "flex",
                "flex-col",
                "gap-16",
              )}
            >
              <div className="">
                <input
                  className={inputBase()}
                  placeholder="email"
                  {...getInputProps(email, {
                    type: "email",
                  })}
                />
                <div className="mt-4">
                  {email.errors && (
                    <ErrorDisplay
                      error={{
                        email: email.errors,
                      }}
                    ></ErrorDisplay>
                  )}
                </div>
              </div>
              <div className="">
                <input
                  className={inputBase()}
                  placeholder="password"
                  {...getInputProps(password, {
                    type: "password",
                  })}
                />
                <div className="mt-4">
                  {password.errors && (
                    <ErrorDisplay
                      error={{
                        password: password.errors,
                      }}
                    ></ErrorDisplay>
                  )}
                </div>
              </div>
            </div>
            <div
              className={clsx(
                "text-center",
                "mt-26",
              )}
            >
              <button
                className={buttonBase({
                  loading:
                    state === "loading" ||
                    state === "submitting",
                })}
                type="submit"
              >
                CREATE ACCOUNT
              </button>
            </div>
          </Form>
        )}
        <div
          className={clsx("text-center", "mt-12")}
        >
          <ErrorDisplay
            error={data?.error ?? undefined}
          ></ErrorDisplay>
        </div>
      </div>
    </div>
  );
}
